import React, { FC, useState } from 'react'
import { Box } from '@chakra-ui/react'
import { Trans, t } from '@lingui/macro'

import IconEye from 'front-end/src/components/common/icon/IconEye'

import { CertificateTemplatePageHeader } from './CertificateTemplatePageHeader'
import { ButtonDanger, ButtonOutline } from 'front-end/src/components'
import IconTrash from '../../../components/common/icon/IconTrash'
import { linkBuilder } from 'shared/linkBuilder'
import { navigateTo } from '../../../app/util/appHistory'
import { Page, PagePanel } from '../../../components/common/page/Page'
import PageHeader from '../../../components/common/page/header/PageHeader'
import GeneralRemoveModal from '../../../components/common/general-remove-modal/GeneralRemoveModal'
import {
  useRemoveTemplateMutation,
  useCertificateTemplatesQuery
} from './CertificateTemplatesPage.codegen'
import { useParams } from 'react-router'

const CertificateTemplateDesigner = React.lazy(
  () => import('./CertificateTemplateDesigner')
)

export const CertificateTemplateSelectedPage: FC = () => {
  const params = useParams<{
    templateId: string
  }>()
  const templateId = parseInt(params.templateId)

  const [removeFn] = useRemoveTemplateMutation()
  const [showRemovalModal, setShowRemovalModal] = useState(false)

  const { data: templatesData, refetch } = useCertificateTemplatesQuery()
  const templates = templatesData?.admin?.organisation?.certificateTemplates

  const defaultTemplate = templates?.find((o) => o.default)
  const selectedTemplate = templates?.find((o) => o.id === templateId)

  if (!selectedTemplate) {
    return null
  }

  return (
    <Page className="Certifications Certifications--templates --with-heading">
      <PageHeader
        className="PageHeader"
        title={t`Manage templates`}
        subHeader={t`These templates will be used to generate certifications for users`}
      />
      <PagePanel>
        <Box pr={4} pl={4} pb="48px">
          <CertificateTemplatePageHeader
            templateId={templateId}
            onSelect={(value) =>
              navigateTo(linkBuilder.certificationsTemplates(value))
            }
            allowCreateNew
            onNewCreated={refetch}
          />

          <CertificateTemplateDesigner id={templateId} />

          <Box d="flex" justifyContent="space-between">
            <ButtonOutline
              onClick={() =>
                navigateTo(
                  linkBuilder.certificationsTemplatePreview(templateId)
                )
              }
              leftIcon={<IconEye />}
            >
              <Trans>Preview</Trans>
            </ButtonOutline>
            {!selectedTemplate?.default && (
              <ButtonDanger
                onClick={() => {
                  setShowRemovalModal(true)
                }}
                leftIcon={<IconTrash />}
              >
                <Trans>Delete this template</Trans>
              </ButtonDanger>
            )}
          </Box>
        </Box>
      </PagePanel>

      <GeneralRemoveModal
        show={showRemovalModal}
        entityName={t`template`}
        confirmButton={t`Delete`}
        onDeleted={() => {
          setShowRemovalModal(false)
        }}
        onCanceled={() => setShowRemovalModal(false)}
        operation={async () => {
          await removeFn({
            variables: {
              id: templateId
            }
          })
          if (defaultTemplate) {
            refetch()
            navigateTo(linkBuilder.certificationsTemplates(defaultTemplate.id))
          }
        }}
      />
    </Page>
  )
}
